import React, { createContext, useContext, useState, useCallback } from 'react';

interface CampaignQuestionsEditorContextType {
    openQuestionIndex: number | null;
    isModalOpen: boolean;
    openModal: (questionIndex: number) => void;
    closeModal: () => void;
}

const CampaignQuestionsEditorContext = createContext<CampaignQuestionsEditorContextType | undefined>(undefined);

export const useCampaignQuestionsEditor = () => {
    const context = useContext(CampaignQuestionsEditorContext);

    if (!context) {
        throw new Error('useCampaignQuestionsEditor must be used within a CampaignQuestionsEditorProvider');
    }

    return context;
};

interface CampaignQuestionsEditorProviderProps {
    children: React.ReactNode;
}

/**
 * Campaign editor context provider.
 */
export const CampaignQuestionsEditorProvider: React.FC<CampaignQuestionsEditorProviderProps> = ({ children }) => {
    const [openQuestionIndex, setOpenQuestionIndex] = useState<number | null>(null);

    const openModal = useCallback((questionIndex: number) => {
        setOpenQuestionIndex(questionIndex);
    }, []);

    const closeModal = useCallback(() => {
        setOpenQuestionIndex(null);
    }, []);

    const isModalOpen = openQuestionIndex !== null;

    return (
        <CampaignQuestionsEditorContext.Provider value={{ openQuestionIndex, isModalOpen, openModal, closeModal }}>
            {children}
        </CampaignQuestionsEditorContext.Provider>
    );
};
